<template>
  <div id="app-div">
    <div class="top">
      <div style="background-color: #f3f3f3; height: 40px; line-height: 40px">
        <div style="float: left">
          <span style="margin-left: 10px; font-size: 15px">
            <a-icon type="search" />筛选查询
          </span>
        </div>
        <!-- <div style="float:right;">
         
        </div> -->
        <div style="clear: both"></div>
        <div style="margin: 19px 20px">
          <label>模版名称：</label>
          <a-input placeholder="请输入" style="width: 200px" />
          <label style="margin-left: 30px">模版类型：</label>
          <a-select
            defaultValue="0"
            style="width: 200px"
            @change="handleChange"
          >
            <a-select-option value="0">全部</a-select-option>
            <a-select-option value="1">收稿</a-select-option>
            <a-select-option value="2">审稿</a-select-option>
            <a-select-option value="3">催审</a-select-option>
            <a-select-option value="4">缴费</a-select-option>
            <a-select-option value="5">催缴</a-select-option>
            <a-select-option value="6">采用</a-select-option>
            <a-select-option value="7">退改</a-select-option>
            <a-select-option value="8">退稿</a-select-option>
          </a-select>
          <label style="margin-left: 30px">创建者：</label>
          <a-input placeholder="请输入" style="width: 200px" />
          <a-button type="primary" style="margin-left: 30px" @click="query"
            >查询</a-button
          >
          <a-button
            type="primary"
            @click="addNote(record)"
            style="margin-top: 4px; float: right"
            >新增</a-button
          >
        </div>
      </div>
    </div>

    <div
      class="middle"
      style="width: 100%; height: 50px; background: #f3f3f3; padding: 10px 0"
    >
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" style="width: 16px" />
        <span>&nbsp;数据列表</span>
      </div>
      <div style="float: right; margin-right: 100px">
        排序方式：
        <a-select defaultValue="1" style="width: 120px" @change="sortChange">
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>

    <div class="bottom">
      <template>
        <div style="border: 2px solid #e8e8e8; width: 100%">
          <a-table
            style="margin: -2px"
            :pagination="false"
            :rowSelection="rowSelection"
            :columns="columns"
            :dataSource="formData"
            :rowKey="(record) => record.columnCode"
            size="small"
            :scroll="{ y: formData.length < 7 ? false : table_height }"
            bordered
          >
            <span slot="operator" slot-scope="text, record">
              <a
                href="javascript:void(0);"
                @click="() => checkMethod(record, 'check')"
                >查看</a
              >
              <a-divider type="vertical" />
              <a
                href="javascript:void(0);"
                @click="() => editMethod(record, 'edit')"
                >编辑</a
              >
              <a-divider type="vertical" />
              <a
                href="javascript:void(0);"
                @click="() => changeStatus(record, '1')"
                >启用</a
              >
              <a-divider type="vertical" />
              <a
                href="javascript:void(0);"
                @click="() => changeStatus(record, '0')"
                >禁用</a
              >
              <a-divider type="vertical" />
              <a
                href="javascript:void(0);"
                @click="() => deleteMethod(record.columnCode)"
                >删除</a
              >
            </span>
            <span slot="status" slot-scope="text, record">
              <label v-if="record.status == '1'">
                <img
                  class="status_img"
                  src="../../../../assets/open.png"
                />已启用
              </label>
              <label v-if="record.status == '0'">
                <img
                  class="status_img"
                  src="../../../../assets/close.png"
                />已禁用
              </label>
            </span>
          </a-table>
        </div>
        <div
          id="components-pagination-demo-mini"
          style="float: right; margin-top: 10px; margin-right: 10px"
        >
          <a-pagination
            :total="total"
            :showTotal="(total) => `共 ${total} 条`"
            showSizeChanger
            showQuickJumper
            @showSizeChange="onShowSizeChange"
            @change="pageChange"
          />
        </div>
      </template>
      <a-select
        defaultValue="0"
        style="width: 120px; margin-top: 10px"
        @change="operateChange"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '模板类型',
    align: 'center',
    dataIndex: 'templateType',
    width: '10%'
  },
  {
    title: '模板名称',
    align: 'center',
    dataIndex: 'templateName',
    width: '10%'
  },
  {
    title: '语言类型',
    align: 'center',
    width: '10%',
    dataIndex: 'languageType'
  },
  {
    title: '状态',
    align: 'center',
    width: '10%',
    dataIndex: 'state'
  },
  {
    title: '创建者',
    align: 'center',
    width: '10%',
    dataIndex: 'creator'
  },
  {
    title: '创建时间',
    align: 'center',
    width: '30%',
    dataIndex: 'createTime'
  },
  {
    title: '操作',
    align: 'center',
    width: '20%',
    dataIndex: 'operate'
  }
];
const formData = [
  {
    templateType: '1',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '查看 编辑'
  },
  {
    templateType: '收稿',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '7'
  },
  {
    templateType: '1',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '7'
  },
  {
    templateType: '1',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '7'
  },
  {
    templateType: '1',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '7'
  },
  {
    templateType: '1',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '7'
  },
  {
    templateType: '1',
    templateName: '2',
    languageType: '3',
    state: '4',
    creator: '5',
    createTime: '6',
    operate: '7'
  }
];
export default {
  name: 'Email',
  data() {
    return {
      value: 1,
      /* queryColumnName: "", */
      columns,
      formData,
      visible: false
    };
  },
  methods: {
    handleChange() {
    },
    sortChange() {
    },
    operateChange() {
    },

    addNote() {
      this.$router.push({
        path: '/addNote'
      });
    }
  }
};
</script>
<style scoped>
.top {
  border: 1px solid;
  border-color: #f3f3f3;
  height: 120px;
}
#app-div {
  margin: 0 auto;
  width: 100%;
}
.middle {
  margin-top: 10px;
}
</style>


